import Vue from 'vue';
import CoreuiVue from '@coreui/vue';
import router from './router';
import store from './store';
import icons from './assets/icons/icons';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import vSelect from 'vue-select';
import FlashAlert from "@/components/shared/FlashAlert";
import FlashToaster from "@/components/shared/FlashToaster";
import flatpickr from "flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es.js";
flatpickr.localize(Spanish);
import VueFlatPickr from 'vue-flatpickr-component';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
import VueCurrencyFilter from 'vue-currency-filter';
import VueCurrencyInput from 'vue-currency-input';
import VueMask from 'v-mask'

import 'flatpickr/dist/flatpickr.css';
//directives
import "@/plugins/directives/auth-roles";
import "@/plugins/directives/readonly-roles";
// filters
import "@/plugins/filters/index";

const moment = require('moment')
require('moment/locale/es')
require('./bootstrap'); import '@babel/polyfill';

import App from './components/App';

require('./bootstrap');

Vue.use(require('vue-moment'), {
    moment,
})
Vue.use(CoreuiVue);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('v-select', vSelect);
Vue.component('FlashAlert', FlashAlert);
Vue.component('FlashToaster', FlashToaster);
Vue.use(VueFlatPickr);
Vue.use(VueMask);

Vue.use(VueFileAgent);
Vue.use(VueSweetalert2);
Vue.use(VueCurrencyInput, {
    globalOptions: {
        currency: null,
        locale: 'de'
    },
});

Vue.use(VueCurrencyFilter,
    {
        symbol: '',
        thousandsSeparator: '.',
        fractionCount: 2,
        fractionSeparator: ',',
        symbolPosition: 'front',
        symbolSpacing: true,
        avoidEmptyDecimals: undefined,
    });
Vue.prototype.$currency = number => Vue.options.filters.currency(number);

store.dispatch('getUser').then(() => {
    const app = new Vue({
        el: '#app',
        components: {
            App
        },
        router,
        store,
        icons
    });
})

